if (!window.Maximize.loadedScript.includes('sticky-atc.js')) {
  window.Maximize.loadedScript.push('sticky-atc.js');

  const init = () => {
    Alpine.store('stickyATC', {
      isOpen: false,
      isFooterShow: false,
      isProductInfoOutOfView: false,
      isOpenDetailOnMobile: false,
      observer: null,
      handleInit(sectionId) {
        if (this.observer) {
          this.observer.disconnect();
        }

        this.scrollY = window.scrollY;
        // Observe the add-to-cart button directly instead of entire section
        let addToCartButton = document.querySelector(`.section--${sectionId} [data-block-type="jump_button"]`);
        if (!addToCartButton) {
          addToCartButton = document.querySelector(`.section--${sectionId} .product-form__btn-add-to-cart`);
        }
        if (!addToCartButton) {
          addToCartButton = document.querySelector(`.section--${sectionId} [data-block-type="buy_buttons"]`);
        }


        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              // Show sticky ATC when add-to-cart button is scrolled PAST (above the viewport)
              // If it's not intersecting and the top is negative, it's scrolled past.
              if (entry.target === addToCartButton) {
                this.isProductInfoOutOfView = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              }
            });
            this.isOpen = this.isProductInfoOutOfView;
          },
          { root: null, threshold: 0 }
        );

        // Only observe the add-to-cart button
        if (addToCartButton) {
          this.observer.observe(addToCartButton);
        }
      }
    })

    Alpine.data('xStickyATC', (stickyATCContainerEl, sectionId) => ({
      isOpenDetailOnMobile: false,
      isFirstLoading: true,
      isMobile: window.innerWidth < MIN_DEVICE_WIDTH.desktop,
      availableOptions: [],
      variantOptionsEle: [],
      options: [],
      optionsSelectedValues: [],
      init() {
        this.optionElements = this.$el.querySelectorAll(`#StickyAddToCart__Variant__${sectionId} .variant-option`)
        this.optionsSelectedValues = this.updateOptionSelectedValues();

        const isMobile = window.matchMedia(`(max-width: ${MIN_DEVICE_WIDTH.desktop - 1}px`);

        const handleMediaChange = (e) => {
          if (e.matches) {
            this.isMobile = true;
            if (!this.isFirstLoading) Alpine.store("stickyATC").isOpenDetailOnMobile = true;
          } else {
            this.isMobile = false;
            Alpine.store("stickyATC").isOpenDetailOnMobile = false;
          }
        };

        handleMediaChange(isMobile);
        isMobile.addEventListener('change', handleMediaChange);
        this.isFirstLoading = false;
      },
      selectOptionSticky(event) {
        const targetOption = event.currentTarget;
        let position = targetOption.dataset.optionPosition;

        this.optionsSelectedValues[Number(position) - 1] = targetOption.dataset.optionValueId;

        document.dispatchEvent(new CustomEvent(`${STICKY_ATC_EVENT.optionChange}-${sectionId}`, {
          detail: {
            optionsSelectedValues: this.optionsSelectedValues
          }
        }));
      },
      updateOptionSelectedValues() {
        const newOptionsSelectedValues = [];

        this.optionElements.forEach((optionEle) => {
          const optionPosition = optionEle.dataset.optionPosition;
          const idx = Number(optionPosition) - 1;
          if (optionEle.classList.contains('selected')) {
            newOptionsSelectedValues[idx] = optionEle.dataset.optionValueId;
          }
        });

        return newOptionsSelectedValues;
      }
    }))
  }

  if (window.Alpine) {
    init();
  } else {
    document.addEventListener('alpine:init', init);
  }
}
